import type { TextProps } from '@react-pdf/renderer';
import { Text } from '@react-pdf/renderer';
import type { ReactElement } from 'react';

import type { Quote } from '@core/types/api/Quote/Quote';
import { randomUUID } from '@core/utils/uuid';

import {
  type PdfColumnConfig,
  PdfTable,
  Styles,
  pdfColumnFromConfig,
} from '../../../components/PdfTable';
import { PdfTextWithLine } from '../../components/PdfTextWithLine';

const textStyle: TextProps['style'] = {
  fontSize: '11pt',
};

const styledText = (text: string, style: TextProps['style']): ReactElement => (
  <Text style={style}>{text}</Text>
);

const formatElementForPdf = (value: ReactElement): ReactElement => value;

type SignatureRow = {
  id: string;
  leftValue: ReactElement;
  rightValue: ReactElement;
};

type PdfSignatureProps = {
  quote: Quote;
};

export const PdfSignatures = (props: PdfSignatureProps): ReactElement => {
  const signatureRows: SignatureRow[] = [
    {
      id: randomUUID(),
      leftValue: (
        <PdfTextWithLine
          text='Joseph P. Carrara & Sons'
          underline
          borderBottom='none'
          textStyle={textStyle}
        />
      ),
      rightValue: (
        <PdfTextWithLine text='Acceptance' underline borderBottom='none' textStyle={textStyle} />
      ),
    },
    {
      id: randomUUID(),
      leftValue: <PdfTextWithLine text='By:' textStyle={textStyle} />,
      rightValue: <PdfTextWithLine text='Company Name:' textStyle={textStyle} />,
    },
    {
      id: randomUUID(),
      leftValue: (
        <Text style={[Styles.tableCell, { paddingLeft: '0.5in' }]}>
          {props.quote.user.fullName()}
        </Text>
      ),
      rightValue: <PdfTextWithLine text='Acknowledged By:' textStyle={textStyle} />,
    },
    {
      id: randomUUID(),
      leftValue: styledText('', {}),
      rightValue: <PdfTextWithLine text='Title:' textStyle={textStyle} />,
    },
    {
      id: randomUUID(),
      leftValue: styledText('', {}),
      rightValue: <PdfTextWithLine text='Date of Acceptance:' textStyle={textStyle} />,
    },
  ];

  const signatureCols: PdfColumnConfig<SignatureRow>[] = [
    {
      id: 'leftValue',
      label: '',
      type: 'custom',
      isDisplayed: false,
      formatValueForPdf: formatElementForPdf as (
        value: ReactElement | string | null,
      ) => ReactElement,
    },
    {
      id: 'rightValue',
      label: '',
      type: 'custom',
      isDisplayed: false,
      formatValueForPdf: formatElementForPdf as (
        value: ReactElement | string | null,
      ) => ReactElement,
    },
  ];

  return <PdfTable columns={signatureCols.map(pdfColumnFromConfig)} rows={signatureRows} />;
};
